import { ConvertDistance } from '@/components/smartUtils/conversion/ConvertDistance'
import { selectLivePositions } from '@/features/domain/device'
import { selectGpsTrackingProvider } from '@/features/domain/user'
import { Text } from '@/local/components'
import { useSelector } from 'react-redux'
import { useTexts } from './useTexts'

import { Box, Stack } from '@mui/material'

interface Props {
  drivers: uui.domain.client.rm.ExtendedDriver[]
}

const growStyle = { height: 42 }

export function DriverInfo(props: Props) {
  const { drivers } = props

  const livePositions = useSelector(selectLivePositions)

  const trackingProvider = useSelector(selectGpsTrackingProvider)

  const texts = useTexts()

  if (drivers.length !== 1) return null

  const { gpsDeviceId, email } = drivers[0].driver.deployment

  const isTelematicsUser = gpsDeviceId !== null && trackingProvider === 'telematics'
  const lastPosition = isTelematicsUser ? livePositions[gpsDeviceId] : null

  return (
    <Box
      data-trackid="navigo-drivers-overview-driverInfo"
      data-testid="navigo-drivers-overview-driverInfo"
      sx={growStyle}
      width="100%"
      flex="0 1 auto"
    >
      <Stack
        direction="column"
        height="100%"
        width="100%"
        flexShrink={0}
        justifyContent="space-between"
      >
        {!isTelematicsUser && (
          <Stack direction="row">
            <Text size="$m">{`${texts.device}:`}&nbsp;</Text>

            <Text
              testid="navigo-drivers-overview-driverInfo-gpsDeviceId"
              weight="$semiBold"
              size="$m"
            >
              {gpsDeviceId ?? texts.notSet}
            </Text>
          </Stack>
        )}

        <Text testid="navigo-drivers-overview-driverInfo-email" size="$m">
          {email}
        </Text>

        {isTelematicsUser && lastPosition && (
          <Stack direction="row" alignItems="flex-end">
            <Text size="$m">{`${texts.overallMileage}:`}&nbsp;</Text>

            <Text
              testid="navigo-drivers-overview-driverInfo-overallMileage"
              weight="$bold"
              size="$m"
            >
              <ConvertDistance meters={lastPosition.odometer} />
            </Text>
          </Stack>
        )}
      </Stack>
    </Box>
  )
}
